import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import SpriteAnimate from '../SpriteAnimate';
import TrustpilotWidget from '../TrustpilotWidget';
import './ValueProps.scss';

const ValueProp = props =>
  (<div className="value-prop">
    <SpriteAnimate height={props.height} width={props.width} numberOfFrames={props.numberOfFrames} src={props.src} />
    <div className="value-prop-text">{props.text}</div>
  </div>);

ValueProp.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  numberOfFrames: PropTypes.number,
  text: PropTypes.string,
  src: PropTypes.string.isRequired,
};

const ValueProps = props =>
  (<div className="value-props">
    <div className="container-guttered">
      <div className="value-props-row">
        <Row colsToRowsOn="fablet-down" rowsSpacedOn="fablet-down">
          {props.valueProps.map((valueProp, i) =>
            (<Col key={i} className="aligned-center value-props-col">
              {valueProp.useTrustpilot ? <TrustpilotWidget templateId="mini" className="value-props-trustpilot-mini" isComponent={false} /> : <ValueProp {...valueProp} /> }
            </Col>)
          )}
        </Row>
      </div>
    </div>
  </div>);

ValueProps.propTypes = {
  valueProps: PropTypes.array,
};

export default ValueProps;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ValueProps/ValueProps.js